export const GET_ASSET_INVENTORY = "GET_ASSET_INVENTORY";
export const FETCH_ASSET_TYPES_REQUEST = "FETCH_ASSET_TYPES_REQUEST";